import React from "react";
import "./EmptyState.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarPlus } from "@fortawesome/free-solid-svg-icons";

interface EmptyStateProps {
  icon?: React.ReactNode;
  message: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon, message }) => (
  <div className="empty-state">
    <div className="empty-state__icon">
      {icon || <FontAwesomeIcon icon={faCalendarPlus} />}
    </div>
    <div className="empty-state__message">{message}</div>
  </div>
);

export default EmptyState;
